import React from 'react'

const ChatToneAiImage = (): JSX.Element => {
    return <img className="w-9 h-9 rounded-full" src="/toneai-logo.png" alt="tone.ai" />
}

export default ChatToneAiImage
